import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import './layer-item-submodel-name-handler.css';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';

type LayerItemSubmodelNameHandlerProps = {
    submodelName: string;
    changeable: boolean;
    onSave: (name: string) => void;
    onCancel: () => void;
};

export type LayerItemSubmodelNameHandlerRef = {
    focusOnSubmodelNameInput: () => void;
};

export const LayerItemSubmodelNameHandler = forwardRef<LayerItemSubmodelNameHandlerRef, LayerItemSubmodelNameHandlerProps>(
    (
        {
            changeable,
            submodelName,
            onCancel,
            onSave
        },
        layerItemSubmodelNameHandlerRef
    ) => {
        const [value, setValue] = useState(submodelName);
        const inputRef = useRef<HTMLInputElement>();

        useImperativeHandle(layerItemSubmodelNameHandlerRef, () => ({
            focusOnSubmodelNameInput: () => {
                if (inputRef.current) inputRef.current.focus();
            }
        }), []);
    
        if (changeable) {
            return (
                <div className='position-relative' onClick={(e) => e.stopPropagation()}>
                    <input
                        autoFocus
                        style={{ width: '100%', paddingRight: '30px' }}
                        type='text'
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        maxLength={255}
                        ref={inputRef as React.LegacyRef<HTMLInputElement>}
                    />
                    <CheckOutlined
                        title='Mentés'
                        style={{
                            color: 'green',
                            position: 'absolute',
                            right: '20px',
                            top: '5px'
                        }}
                        onClick={() => onSave(value)}
                    />
                    <CloseOutlined
                        title='Elvetés'
                        style={{
                            color: 'red',
                            position: 'absolute',
                            right: '3px',
                            top: '5px'
                        }}
                        onClick={
                            () => {
                                setValue(submodelName);
                                onCancel();
                            }
                        }
                    />
                </div>
            );
        }

        return (
            <span className='layer-item-model-name-handler-submodel-name'>
                {
                    submodelName ? submodelName : '?'
                }
            </span>
        );
    }
);